import crudService from '../config/crudService';
//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js

export const crudGeneral = crudService;
export const classGeneralCRUD = {
    //Algo fora do padrão, mas geral de acordo com este contexto
}

export default {
    crudGeneral,
    classGeneralCRUD
}
